<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<template>
  <div class="one-column-width">
    <!-- form start -->
    <v-card class="r_tabsform_card mb-5">
      <v-card-title class="r_form_card_title ext_pdg_to_lvl">
        Post a Job</v-card-title
      >
      <hr class="r_form_card_top_hr" />
      <div class="col-md-12 mx-5 my-0">
        <div class="col-md-12 row pb-0">
          <div class="col-md-3">
            <!-- <label>Name <span class="text-danger">*</span></label> -->
            <input
              type="text"
              class="r_formtabs_inputs m-0 w-100"
              placeholder="Job title"
              v-model="job_title"
            />
          </div>

          <div class="col-md-3">
            <!-- <label>Institute <span class="text-danger">*</span></label> -->

            <v-autocomplete
              v-model="minimum_qualification_level"
              :items="qualification_levels"
              label="Minimum qualification"
              class="r_formtabs_inputs m-0 w-100"
            ></v-autocomplete>
          </div>

          <div class="col-md-5">
            <!-- <label>Name <span class="text-danger">*</span></label> -->

            <multiselect
              class="slect_home_hero overflow-x-h w-100"
              v-model="selected_qualifications"
              :height="300"
              :options="all_qualifications"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              placeholder="Preferred qualifications"
              label="value"
              track-by="value"
              :preselect-first="false"
            >
            </multiselect>
          </div>
          <div class="col-md-3">
            <!-- <label>Name <span class="text-danger">*</span></label> -->
            <input
              type="text"
              class="r_formtabs_inputs m-0 w-100"
              v-model="minimum_experience"
              placeholder="Minimum experience"
            />
          </div>
          <div class="col-md-3">
            <!-- <label>Name <span class="text-danger">*</span></label> -->

            <multiselect
              class="slect_home_hero overflow-x-h w-100"
              v-model="selected_genders"
              :height="300"
              :options="all_genders"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              placeholder="Gender"
              label="value"
              track-by="value"
              :preselect-first="false"
            >
            </multiselect>
          </div>
          <div class="col-md-5">
            <!-- <label>Name <span class="text-danger">*</span></label> -->
            <multiselect
              class="slect_home_hero overflow-x-h w-100"
              v-model="selected_cities"
              :height="300"
              :options="all_cities"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              placeholder="Job city"
              label="value"
              track-by="value"
              :preselect-first="false"
            >
            </multiselect>
          </div>
          <div class="col-md-3">
            <!-- <label>Name <span class="text-danger">*</span></label> -->
            <input
              type="number"
              v-model="no_of_vacancies"
              class="r_formtabs_inputs m-0 w-100"
              placeholder="No. of vacancies"
            />
          </div>
          <div class="col-md-3">
            <!-- <label>Name <span class="text-danger">*</span></label> -->
            <input
              type="text"
              onfocus="(this.type='date')"
              onblur="(this.type='text')"
              class="r_formtabs_inputs m-0 w-100"
              v-model="applications_deadline"
              placeholder="Apply by (Application Deadline)"
            />
          </div>

          <div class="col-md-3 col-sm-12 mt-3">
            <input
              type="checkbox"
              class="mr-3"
              id="delete_after_expiry"
              v-model="delete_after_expiry"
            />
            <label for="delete_after_expiry">delete after expiry?</label>
          </div>
        </div>
        <p v-if="basicFormErr" class="text-sm text-danger">
          please fill all the fields correctly
        </p>
      </div>
      <hr class="r_form_card_top_hr" />
      <v-card-title class="r_form_card_sub_title ext_pdg_to_lvl">
        Required skills</v-card-title
      >
      <div class="col-md-12 mx-5 my-0 pt-0">
        <div
          class="col-md-12 row pt-0"
          v-for="(item, index) in educationSkill"
          :key="index"
        >
          <div class="col-md-5">
            <!-- <label>Name <span class="text-danger">*</span></label> -->
            <v-autocomplete
              v-model="item.jobFunction"
              :items="all_job_functions"
              label="Job function"
              class="r_formtabs_inputs m-0 w-100"
            ></v-autocomplete>
          </div>

          <div class="col-md-5">
            <!-- <label>Institute <span class="text-danger">*</span></label> -->
            <multiselect
              class="slect_home_hero overflow-x-h w-100"
              v-model="item.skill"
              :height="300"
              :options="all_skills"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              placeholder="Required Skills"
              label="value"
              track-by="value"
              :preselect-first="false"
            >
            </multiselect>
          </div>
          <div class="col-lg-2 col-md-6 col-sm-12">
            <button
              class="r_form_add_more_recods_btnnn"
              type="button"
              @click="addNewEducationSkillRow()"
            >
              Add
            </button>
            <button
              v-if="index > 0"
              class="r_cust_del_new_rec_btn"
              type="button"
              @click="deleteEducationSkillRow(index)"
            >
              Delete
            </button>
          </div>
        </div>
        <p v-if="educationSkillsErr" class="text-sm text-danger">
          please select all the job functions and the required skills
        </p>
      </div>
      <hr class="r_form_card_top_hr" />
      <v-card-title class="r_form_card_sub_title ext_pdg_to_lvl">
        Nature of the job</v-card-title
      >
      <div class="col-md-12 mx-5 my-0 pt-0">
        <div class="col-md-12 row pt-0">
          <div class="col-md-3 col-sm-12">
            <input
              type="checkbox"
              class="mr-3"
              id="featured_job"
              v-model="featured_job"
            />
            <label for="featured_job">Featured</label>
          </div>
          <div class="col-md-3 col-sm-12">
            <input
              type="checkbox"
              class="mr-3"
              id="spot_light"
              v-model="spot_light"
            />
            <label for="spot_light">Spotlight</label>
          </div>
          <div class="col-md-6 col-sm-12">
            <input
              type="checkbox"
              class="mr-3"
              id="urgent_hiring"
              v-model="urgent_hiring"
            />
            <label for="urgent_hiring">Urgent</label>
          </div>

          <div class="col-md-4">
            <!-- <label>Institute <span class="text-danger">*</span></label> -->

            <multiselect
              class="slect_home_hero overflow-x-h w-100"
              v-model="selected_career_levels"
              :height="300"
              :options="all_career_levels"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              placeholder="Career Level"
              label="value"
              track-by="value"
              :preselect-first="false"
            >
            </multiselect>
          </div>
          <div class="col-md-4">
            <!-- <label>Institute <span class="text-danger">*</span></label> -->
            <multiselect
              class="slect_home_hero overflow-x-h w-100"
              v-model="selected_job_shifts"
              :height="300"
              :options="all_job_shifts"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              placeholder="Job shift"
              label="value"
              track-by="value"
              :preselect-first="false"
            >
            </multiselect>
          </div>
          <div class="col-md-4">
            <!-- <label>Institute <span class="text-danger">*</span></label> -->
            <multiselect
              class="slect_home_hero overflow-x-h w-100"
              v-model="selected_job_types"
              :height="300"
              :options="all_job_types"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              placeholder="Job type"
              label="value"
              track-by="value"
              :preselect-first="false"
            >
            </multiselect>
          </div>
        </div>
        <p v-if="jobNatureErr" class="text-sm text-danger">
          please select career level, job shift and job type correctly
        </p>
      </div>
      <hr class="r_form_card_top_hr" />
      <v-card-title class="r_form_card_sub_title ext_pdg_to_lvl">
        Compensation & benefits</v-card-title
      >
      <div class="col-md-12 mx-5 my-0 pt-0">
        <div class="col-md-12 row pt-0">
          <div
            class="col-md-3 col-sm-12"
            :class="
              depends_on_experience != '' ||
              (min_salary != '' && max_salary != '')
                ? 'opacity-50'
                : ''
            "
          >
            <input
              type="checkbox"
              id="marke_competative"
              class="mr-3"
              v-model="market_competative"
              @change="compensationBenifitsValidation('market_competative')"
              :disabled="
                depends_on_experience != '' ||
                  (min_salary != '' && max_salary != '')
              "
            />
            <label for="marke_competative">Market Competitive</label>
          </div>
          <div
            class="col-md-9 col-sm-12"
            :class="
              market_competative != '' || (min_salary != '' && max_salary != '')
                ? 'opacity-50'
                : ''
            "
          >
            <input
              type="checkbox"
              id="depen_on_exp"
              class="mr-3"
              v-model="depends_on_experience"
              @change="compensationBenifitsValidation('depends_on_experience')"
              :disabled="
                market_competative != '' ||
                  (min_salary != '' && max_salary != '')
              "
            />
            <label for="depen_on_exp">Depending on experience</label>
          </div>

          <div
            class="col-md-4"
            :class="
              market_competative != '' || depends_on_experience != ''
                ? 'opacity-50'
                : ''
            "
          >
            <!-- <label>Institute <span class="text-danger">*</span></label> -->
            <input
              class="r_formtabs_inputs m-0 w-100"
              placeholder="Min Salary"
              v-model="min_salary"
              @keyup="compensationBenifitsValidation('min_salary')"
              :disabled="
                market_competative != '' || depends_on_experience != ''
              "
            />
          </div>
          <div
            class="col-md-4"
            :class="
              market_competative != '' || depends_on_experience != ''
                ? 'opacity-50'
                : ''
            "
          >
            <!-- <label>Institute <span class="text-danger">*</span></label> -->
            <input
              class="r_formtabs_inputs m-0 w-100"
              placeholder="Max Salary"
              v-model="max_salary"
              @keyup="compensationBenifitsValidation('max_salary')"
              :disabled="
                market_competative != '' || depends_on_experience != ''
              "
            />
          </div>
          <div class="col-md-4">
            <!-- <label>Institute <span class="text-danger">*</span></label> -->
            <multiselect
              class="slect_home_hero overflow-x-h w-100"
              v-model="selected_benifits"
              :height="300"
              :options="all_benefits_options"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              placeholder="Benifits"
              label="value"
              track-by="value"
              :preselect-first="false"
              :class="benefitsErr == true ? 'validation-error' : 'validated'"
            >
            </multiselect>
            <p v-if="benefitsErr" class="text-sm text-danger">
              please select benefits you offer
            </p>
          </div>
        </div>
        <p v-if="compensationBenifitsErrors" class="text-sm text-danger">
          {{ compensationBenifitsErrors }}
        </p>
      </div>
      <hr class="r_form_card_top_hr" />
      <v-card-title class="r_form_card_sub_title ext_pdg_to_lvl">
        Questions</v-card-title
      >
      <div class="col-md-12 mx-5 my-0 pt-0">
        <div
          class="col-md-12 row pt-0"
          v-for="(item, index) in qa"
          :key="index"
        >
          <div class="col-md-3">
            <!-- <label>Institute <span class="text-danger">*</span></label> -->
            <input
              type="text"
              v-model="item.question"
              class="r_formtabs_inputs m-0 w-100"
              placeholder="Enter question"
            />
          </div>
          <div class="col-md-3">
            <v-autocomplete
              v-model="item.type"
              :items="qaTypes"
              label="Job function"
              class="r_formtabs_inputs m-0 w-100"
            ></v-autocomplete>
          </div>

          <div class="col-md-6 row">
            <div class="col-md-8 p-0" v-if="item.type == 'multi'">
              <v-combobox
                class="r_formtabs_inputs m-0 w-100"
                v-if="item.type == 'multi'"
                v-model="item.answer"
                hide-selected
                label="Options"
                multiple
                persistent-hint
                small-chips
                :search-input.sync="search"
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        Double click to edit & press
                        <kbd>enter</kbd> to create a new one
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-combobox>
            </div>
            <div class="col-md-4 pt-2">
              <input
                type="checkbox"
                class="mr-3"
                v-model="item.mandatory"
                required
                :id="item.type"
              />
              <label :for="item.type">Mandatory?</label>
            </div>
          </div>
          <div class="col-md-6 col-sm-12">
            <button
              class="r_form_add_more_recods_btnnn"
              type="button"
              @click="addNewQuestionRow()"
            >
              Add
            </button>
            <button
              v-if="index > 0"
              class="r_cust_del_new_rec_btn"
              type="button"
              @click="removeQuestionRow(index)"
            >
              Delete
            </button>
          </div>
        </div>
        <p v-if="qaErr" class="text-sm text-danger">
          please select all values correctly
        </p>
      </div>
      <hr class="r_form_card_top_hr" />
      <v-card-title class="r_form_card_sub_title ext_pdg_to_lvl">
        Description</v-card-title
      >
      <div class="col-md-12 mx-5 my-0 pt-0">
        <div class="col-md-12 row pt-0">
          <div class="col-md-12 col-sm-12">
            <vue-editor
              outlined
              class="r_formtabs_text_area m-0 w-100 p-0"
              label="About"
              rows="2"
              v-model="job_description"
              placeholder="Job description"
            ></vue-editor>
          </div>
        </div>
        <p v-if="jobDescriptionErr" class="text-sm text-danger">
          please write job description
        </p>
      </div>
      <hr class="r_form_card_top_hr" />
      <v-card-title class="r_form_card_sub_title ext_pdg_to_lvl">
        Institutes
      </v-card-title>
      <div class="mx-5 my-0 pt-0">
        <div class="row pt-0">
          <div class="col-md-5 p-0">
            <multiselect
              class="slect_home_hero overflow-x-h w-100"
              id="multiselectCities"
              v-model="selected_universities"
              :height="300"
              :options="all_universities"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              placeholder="Select Institutes to share the job"
              label="value"
              track-by="value"
              :preselect-first="false"
            >
            </multiselect>
          </div>
        </div>
        <p v-if="selectInstitutesErr" class="text-sm text-danger">
          please select institutes to share the job with
        </p>
      </div>
      <!--finel button -->
      <div class="col-md-6">
        <button
          type="button"
          class="r_form_add_more_btnnn m-0"
          @click="publishJob()"
        >
          Publish Job
        </button>
        <button
          type="button"
          class="r_form_add_more_btnnn m-0 ml-2 bg-light-blue-ch"
        >
          Save Job as Draft
        </button>
        <button type="button" class="r_form_cancel_more_btnnn m-0">
          Cancel
        </button>
      </div>
      <br />
    </v-card>
    <!-- form end -->
  </div>
</template>

<script>
import AdmissionForm from "@/MainServices/AdmissionForm.js";
import { required, minLength } from "vuelidate/lib/validators";
import { mapGetters, mapState } from "vuex";
import { VueEditor } from "vue2-editor";
import axios from "axios";
import API from "@/core/api";
import Multiselect from "vue-multiselect";
import IndexService from "@/MainServices/IndexService.js";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      user_id: 0,
      job_title: "",
      educationSkill: [{ jobFunction: "", skill: [] }],
      qa: [{ question: "", type: null, answer: "", mandatory: false }],
      jobFunctionsOptions: [],
      degreeSubjectOptions: [],
      degreeSubject: null,
      salaryRules: [
        // (v) =>
        // (v) => !!v || "Field is required",
        (v) => (!parseInt(v) ? "Field should be number" : ""),
        // (v) => (v && v.length <= 10) || "Title must be less than 25 characters",
      ],
      qualification_levels: [],
      minimum_qualification_level: "",
      all_qualifications: [],
      selected_qualifications: [],
      all_genders: [],
      qaErr: false,
      selected_genders: [],
      all_cities: [],
      selected_cities: [],
      all_job_functions: [],
      all_skills: [],
      all_career_levels: [],
      selected_career_levels: [],
      all_job_shifts: [],
      selected_job_shifts: [],
      all_job_types: [],
      selected_job_types: [],
      all_benefits_options: [
        { value: "Commission", text: "Commission" },
        { value: "Pension", text: "Pension" },
        { value: "Provident Fund", text: "Provident Fund" },
        { value: "Compnay Transport", text: "Compnay Transport" },
        { value: "Car Allowance", text: "Car Allowance" },
        { value: "Housing Allowance", text: "Housing Allowance" },
      ],
      selected_benifits: [],
      qaTypes: [
        { value: null, text: "Select Type" },
        { value: "radio", text: "Options: Yes, No" },
        { value: "multi", text: "Multiple Options" },
        { value: "textarea", text: "Free Text" },
      ],
      all_universities: [],
      selected_universities: [],
      market_competative: false,
      depends_on_experience: false,
      min_salary: "",
      max_salary: "",
      minimum_experience: "",
      delete_after_expiry: false,
      featured_job: false,
      spot_light: false,
      urgent_hiring: false,
      no_of_vacancies: "",
      applications_deadline: "",
      job_description: "",
      basicFormErr: false,
      educationSkillsErr: false,
      jobNatureErr: false,
      benefitsErr: "",
      compensationBenifitsError: false,
      compensationBenifitsErrors: "",
      qaQuestionErr: [],
      qaTypesErr: [],
      qaAnswereErr: [],
      jobDescriptionErr: false,
      selectInstitutesErr: false,
      editId: null,
      deleteId: null,
      dialog: false,
      snackbar: false,
      snackBarText: null,
      deleting: false,
      errorMessage: false,
      search: "",
      showFormData: false,
      applicationValues: null,
      tokens: [
        "HtDFLJIJNa4mwOEHAw45TLtgLy3Zzi3k85kKZV6p",
        "HtDFLJI54236wOEHAw4grop1Ly3Zzi3k85kKZV6p",
        "HtDF7ybds236wOEHAw4grop1Ly3Zzi3mnbvcZV6p",
        "HtDFpoi8u236wOEHAw4grop1Ly3ZqwertbvcZV6p",
        "HtDFpoi8u236wOE45698rop1Ly3Zqwe52031ZV6p",
        "HtDFpoi8u236wOE45698ropoijhbvcxz2031ZV6p",
        "HtDFpoi8u236wOE45698rop123poi456t031ZV6p",
        "HtDFpoi8u236wOE456qwedsa3456bf8sj031ZV6p",
        "HtDFpoi8u236wOE45698rop12742651erts1ZV6p",
        "HtDFpoi8u236wOE456qwed745632ertuj031ZV6p",
      ],
      token: `Bearer ${localStorage.getItem("token")}`,
    };
  },
  components: { Multiselect, VueEditor },

  computed: {
    ...mapGetters(["currentUser"]),
  },

  methods: {
    compensationBenifitsValidation(el) {
      var value = false;
      var minMaxErr = false;
      if (el == "market_competative") {
        if (this.market_competative == true) {
          this.min_salary = "";
          this.max_salary = "";
          this.depends_on_experience = false;
          value = true;
        } else {
          value = false;
        }
      } else if (el == "depends_on_experience") {
        if (this.depends_on_experience == true) {
          this.min_salary = "";
          this.max_salary = "";
          this.marke_competative = false;
          value = true;
        } else {
          value = false;
        }
      } else if (el == "min_salary" || el == "max_salary") {
        if (this.min_salary != "" && this.max_salary != "") {
          if (isNaN(this.min_salary) || isNaN(this.max_salary)) {
            minMaxErr = true;
            value = false;
          } else if (this.min_salary <= this.max_salary) {
            this.marke_competative = false;
            this.depends_on_experience = false;
            value = true;
          } else {
            minMaxErr = true;
            value = false;
          }
        } else {
          value = false;
        }
      }

      if (value == false) {
        this.compensationBenifitsError = true;
        if (minMaxErr == true) {
          this.compensationBenifitsErrors =
            "Minimun salary must be less than maximum salary.";
        } else {
          this.compensationBenifitsErrors =
            "Please either select the min. & max. salary range Or 'Market Competitive' or 'Depending on Experience'";
        }
      } else {
        this.compensationBenifitsErrors = "";
        this.compensationBenifitsError = false;
      }
    },

    publishJob() {
      if (
        this.job_title == "" ||
        this.minimum_qualification == "" ||
        this.selected_qualifications.length == 0 ||
        this.minimum_experience == "" ||
        this.selected_genders.length == 0 ||
        this.selected_cities.length == 0 ||
        this.no_of_vacancies == "" ||
        this.applications_deadline == ""
      ) {
        this.basicFormErr = true;
      } else {
        this.basicFormErr = false;
      }

      if (
        this.market_competative == false &&
        this.depends_on_experience == false &&
        this.min_salary == "" &&
        this.max_salary == ""
      ) {
        this.compensationBenifitsError = true;
        this.compensationBenifitsErrors =
          "Please either select the min. & max. salary range Or 'Market Competitive' or 'Depending on Experience'";
      } else {
        this.compensationBenifitsError = false;
        this.compensationBenifitsErrors = "";
      }

      for (let index = 0; index < this.educationSkill.length; index++) {
        if (
          this.educationSkill[index].jobFunction == "" ||
          this.educationSkill[index].skill == ""
        ) {
          this.educationSkillsErr = true;
          break;
        } else {
          this.educationSkillsErr = false;
        }
      }

      for (let index = 0; index < this.qa.length; index++) {
        if (this.qa[index].question == "" || this.qa[index].type == null) {
          this.qaErr = true;
          break;
        } else {
          if (
            this.qa[index].type == "multi" &&
            (this.qa[index].answer == "" || this.qa[index].answer.length == 0)
          ) {
            this.qaErr = true;
            break;
          }
          this.qaErr = false;
        }
      }

      if (
        this.selected_career_levels.length == 0 ||
        this.selected_job_shifts.length == 0 ||
        this.selected_job_types.length == 0
      ) {
        this.jobNatureErr = true;
      } else {
        this.jobNatureErr = false;
      }

      if (this.job_description == "") {
        this.jobDescriptionErr = true;
      } else {
        this.jobDescriptionErr = false;
      }

      if (this.selected_universities.length == 0) {
        this.selectInstitutesErr = true;
      } else {
        this.selectInstitutesErr = false;
      }

      if (
        this.basicFormErr == false &&
        this.compensationBenifitsError == false &&
        this.educationSkillsErr == false &&
        this.qaErr == false &&
        this.jobNatureErr == false &&
        this.jobDescriptionErr == false &&
        this.selectInstitutesErr == false
      ) {
        let c = [];
        this.selected_cities.map((el) => {
          c.push(el.value);
        });
        let genders = [];
        this.selected_genders.map((el) => {
          genders.push(el.value);
        });
        let benefits = [];
        this.selected_benifits.map((el) => {
          benefits.push(el.value);
        });
        let jobType = [];
        this.selected_job_types.map((el) => {
          jobType.push(el.value);
        });
        let universities = [];
        this.selected_universities.map((el) => {
          universities.push(el.value);
        });
        let experience = [];
        this.selected_career_levels.map((el) => {
          experience.push(el.value);
        });
        let job_function = [];
        let require_skills = [];

        this.educationSkill.map((el) => {
          this.all_job_functions.map((el1) => {
            if (el1.value == el.jobFunction) {
              job_function.push(el1.text);
            }
          });

          el.skill.map((el2) => {
            require_skills.push(el2.value);
          });
        });
        // console.log(this.educationSkill);
        // console.log(job_function);
        // console.log(require_skills);

        let minimum_qualification_level = "";
        this.qualification_levels.map((el) => {
          if (el.value == this.minimum_qualification_level) {
            minimum_qualification_level = el.text;
          }
        });
        let qualifications = [];
        this.selected_qualifications.map((el) => {
          qualifications.push(el.value);
        });
        let job_shift = [];
        this.selected_job_shifts.map((el) => {
          job_shift.push(el.value);
        });
        axios.defaults.headers.common["Authorization"] = this.token;
        axios.post(`${API.API_JOB4U}/myuni-std-save-jobs`, {
          job_title: this.job_title, //ok
          minimum_experience_years: this.minimum_experience, //ok
          gender: genders, //ook
          no_of_vacancies: this.no_of_vacancies,
          education: minimum_qualification_level, //ok
          degree_subject: qualifications,
          apply_by: this.applications_deadline, //ok
          location_city: c, //ok
          user_id: this.user_id,
          job_function: job_function,
          require_skills: require_skills,
          job_shift: job_shift,
          featured: this.featured_job == true ? 1 : 0,
          spotlight: this.spot_light == true ? 1 : 0,
          urgent: this.urgent_hiring == true ? 1 : 0,
          market_competitive: this.market_competative == true ? 1 : 0,
          depends_on_exp: this.depends_on_experience == true ? 1 : 0,
          experience: experience,
          benefits: benefits,
          salary_min: this.min_salary,
          // salary_max: this.salary_range.split('- ')[1],
          salary_max: this.max_salary,
          job_type: jobType,
          job_description: this.job_description,
          questions: this.qa,
          job4u_post: 0,
          my_uni_post: 1,
          show_salary_to_login_users: 1,
          delete_after_expiry: this.delete_after_expiry == true ? 1 : 0,
          my_uni_selected_universities: this.selected_universities,
        });
      } else {
        Swal.fire({
          title: "",
          text: "Please, provide correct data!",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
      }
    },

    addNewEducationSkillRow() {
      this.educationSkill.push({
        jobFunction: "",
        skill: "",
      });
    },
    deleteEducationSkillRow(index) {
      var temp = [];
      this.educationSkill.forEach((element, i) => {
        if (i !== index) temp.push(element);
      });
      this.educationSkill = temp;
    },

    addNewQuestionRow() {
      this.qa.push({ question: "", type: null, answer: [], mandatory: false });
    },
    removeQuestionRow(index) {
      var temp = [];
      this.qa.forEach((element, i) => {
        if (i !== index) temp.push(element);
      });
      this.qa = temp;
    },

    getInititalData() {
      AdmissionForm.getStudentApplications()
        .then((res) => {
          this.tableData = res.data;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // main methods
    showEditForm(item) {
      this.applicationValues = JSON.parse(item.values);
      this.editId = item.id;
      this.showFormData = true;
    },
    cancelForm() {
      this.showFormData = false;
    },
    askUserAboutDelete(item) {
      this.deleteId = item.id;
      this.dialog = true;
    },
    deleteItem() {
      this.deleting = true;
      CampusService.deleteCampus(this.deleteId)
        .then((res) => {
          this.editId = null;
          this.deleting = false;
          this.dialog = false;
          this.resetForm();
          this.getInititalData();
          this.snackBarText = "Campus Deleted successful!";
          this.snackbar = true;
        })
        .catch((error) => {
          this.errorMessage = true;
          this.dialog = false;
        });
    },
  },
  mounted() {
    this.getInititalData();

    IndexService.getEnrolledUniversites().then((res) => {
      this.all_universities = [];
      this.user_id = res.data.user_id;
      res.data[0].map((el) => {
        this.all_universities.push({ id: el.id, value: el.name });
      });
    });

    axios.defaults.headers.common["Authorization"] = this.token;
    let t = this.tokens[Math.floor(Math.random() * 10)];

    axios
      .post(`${API.API_JOB4U}/myuni-std-jobs`, {
        token: t,
      })
      .then((res) => {
        if (res.data.education.length > 0) {
          this.qualification_levels = [];
          res.data.education.map((el) => {
            this.qualification_levels.push({
              value: el.id,
              text: el.qualification_level,
            });
          });

          this.all_genders = [];
          res.data.genders.map((el) => {
            this.all_genders.push({
              id: el.id,
              value: el.gender_name,
            });
          });

          this.all_cities = [];
          res.data.cities.map((el) => {
            this.all_cities.push({
              id: el.id,
              value: el.city_name,
            });
          });

          this.all_job_functions = [];
          res.data.jobFunctions.map((el) => {
            this.all_job_functions.push({
              value: el.id,
              text: el.job_function_name,
            });
          });

          this.all_skills = [];
          res.data.skills.map((el) => {
            this.all_skills.push({
              id: el.id,
              value: el.skill_name,
            });
          });

          this.all_career_levels = [];
          res.data.experience.map((el) => {
            this.all_career_levels.push({
              id: el.id,
              value: el.career_level,
            });
          });

          this.all_job_shifts = [];
          res.data.jobShifts.map((el) => {
            this.all_job_shifts.push({
              id: el.id,
              value: el.job_shift,
            });
          });

          this.all_job_types = [];
          res.data.jobTypes.map((el) => {
            this.all_job_types.push({
              id: el.id,
              value: el.job_type,
            });
          });
        }
      })
      .catch((err) => {
        // console.log("err", err);
      });

    // get all degrees from job for you
    t = this.tokens[Math.floor(Math.random() * 10)];
    axios
      .post(`${API.API_JOB4U}/myuni-std-get-degrees`, {
        token: t,
      })
      .then((res) => {
        if (res.data) {
          this.all_qualifications = [];

          res.data.map((el) => {
            this.all_qualifications.push({
              id: el.id,
              value: el.subject_name,
            });
          });
        }
      })
      .catch((err) => {
        // console.log("err", err);
      });
  },
};
</script>

<style scoped>
.text-success {
  color: #2eca8b !important;
}
.text-danger {
  color: #a82511 !important;
}
</style>
